// extracted by mini-css-extract-plugin
export default {"popup_wrap":"awardError_popup_wrap__kx6ri","popup_message":"awardError_popup_message__tBIKP","popup_message_button":"awardError_popup_message_button__+g6Kz"};